import type { ReactNode } from "react";
import { useLayoutEffect } from "react";
import { BezpartHeader } from "./BezpartHeader";
import { useAuthPageBody } from "../hooks/useAuthPageBody";
import "../styles/air-pages.css";

type Props = {
  children: ReactNode;
  loginHref?: string;
};

/**
 * Вход и регистрация — в воздушном стиле главной (styles/air-pages.css):
 * слева короткий тонкий заголовок, справа форма в тонкой рамке. Человек
 * нажимает «Начать бесплатно» на лёгкой главной и попадает сюда — страница
 * не должна выглядеть как другой сайт.
 */
export function AuthPageShell({ children, loginHref }: Props) {
  useAuthPageBody();
  // До отрисовки: иначе кнопка на миг мелькала прежним цветом.
  useLayoutEffect(() => {
    document.body.classList.add("wb-page--air");
    return () => document.body.classList.remove("wb-page--air");
  }, []);

  return (
    <>
      <BezpartHeader mode="guest" loginHref={loginHref} />
      <main className="wb-air-auth">
        <div className="wb-air-auth__aside">
          <p className="wb-air-auth__eyebrow">Bezpart Доска</p>
          <p className="wb-air-auth__title">
            Онлайн-доска
            <span>для живых занятий</span>
          </p>
          <ul className="wb-air-auth__points">
            <li>Три доски — бесплатно</li>
            <li>Работает в браузере, ничего не нужно устанавливать</li>
            <li>Доски хранятся в кабинете и не пропадают после урока</li>
          </ul>
        </div>
        <div className="wb-auth-card wb-card">{children}</div>
      </main>
    </>
  );
}
